<!-- TODO (GB-7600): add shared translations -->
<span matSnackBarLabel>{{ data.message }}</span>
<span matSnackBarActions>
  <button class="action-button" mat-button matSnackBarAction (click)="action(true)">Yes</button>
  <button class="action-button" mat-button matSnackBarAction (click)="action(false)">No</button>
</span>
